import { Avatar, Stack, Typography } from '@mui/material';
import { ChatChannelType } from 'tdc-web-backend/enums/enums';
import { RecentChannelDto } from 'tdc-web-backend/channels/schemas';
import { useTranslation } from 'react-i18next';
import { enUS, hr } from 'date-fns/locale';
import { formatDistanceToNow } from 'date-fns';
import useMode from '../../../utils/hooks/useMode';
import { EnumMode } from '../../../utils/context/Mode.context';

type RecentChannelProps = {
  recentChannel: RecentChannelDto;
  onClick: () => void;
};

export default ({ recentChannel, onClick }: RecentChannelProps) => {
  const { mode } = useMode();
  const { project } = recentChannel.channel.space;
  const otherCompany = mode === EnumMode.Supplier ? project?.seller : project?.buyer;
  const { t, i18n } = useTranslation();
  const dateAdapterLocale = i18n.language === 'hr' ? hr : enUS;

  return (
    <Stack
      direction="row"
      p="10px"
      gap="10px"
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'secondaryBlue.50',
        },
      }}
    >
      <Avatar src={otherCompany?.avatar} />
      <Stack flex="1">
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Typography variant="bodyMedium3" color="primaryDark.600">
            {recentChannel.channel?.type === ChatChannelType.Public
              ? `# ${recentChannel.channel.name}`
              : `${recentChannel.user.firstName} ${recentChannel.user.lastName}`}
          </Typography>
          <Typography variant="bodySemiBold4" color="primaryDark.400">
            {formatDistanceToNow(new Date(recentChannel.created), {
              addSuffix: true,
              locale: dateAdapterLocale,
            })}
          </Typography>
        </Stack>
        <Typography variant="body4" fontSize={11} color="primaryDark.500">
          {recentChannel.body}
        </Typography>
      </Stack>
    </Stack>
  );
};
